export { default } from './CategoriesPanel';
